import React, {useEffect} from 'react';
import './Pages.css';

function SollaiSolPrivacy() {
  useEffect (() => {
      try {
        (window.adsbygoogle = window.adsbygoogle || []).push({});
        console.log('Ad showing...');
      } catch (e) {
        console.error('Adsense error:', e);
      }
    }, []);

  return (
    <div className="page-container">
      <div className="privacy-container">
        <h1>Privacy Policy - Sollai Sol</h1>
        <p className="effective-date"><strong>Effective date: November 8, 2025</strong></p>

        <p>
          Sollai Sol ("we", "our", or "us"), developed by Ulaga Tamizhar, values your privacy.
          This Privacy Policy explains how we handle information when you use our mobile application ("App").
        </p>

        <section className="privacy-section">
          <h2>1. Information Collection</h2>
          <p>Our app itself does not collect, store, or share any personal information.</p>
          <p>
            However, Sollai Sol uses Google AdMob to display ads. AdMob may automatically collect certain data, including:
          </p>
          <ul>
            <li>Device identifiers (such as Android Advertising ID)</li>
            <li>Approximate location (for ad relevance)</li>
            <li>App interaction and usage data (for ad performance)</li>
          </ul>
          <p>This information helps deliver relevant ads and improve user experience.</p>
          <p>
            For details on how Google handles this data, please see the{' '}
            <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">
              Google Privacy Policy
            </a>.
          </p>
        </section>

        <section className="privacy-section">
          <h2>2. Data Use</h2>
          <p>The information collected by AdMob is used only for:</p>
          <ul>
            <li>Serving and improving personalized or non-personalized ads</li>
            <li>Measuring ad performance</li>
          </ul>
          <p>We do not have access to or control over the data collected by AdMob.</p>
        </section>

        <section className="privacy-section">
          <h2>3. Children's Privacy</h2>
          <p>
            Sollai Sol is designed for general audiences and does not knowingly collect personal data from children under the age of 13.
            If you believe a child has provided personal information, please contact us so we can delete it.
          </p>
        </section>

        <section className="privacy-section">
          <h2>4. Data Security</h2>
          <p>We take reasonable steps to ensure that your information is protected.</p>
          <p>
            As AdMob handles all ad-related data, please refer to Google's security and privacy practices for more details.
          </p>
        </section>

        <section className="privacy-section">
          <h2>5. Changes to This Policy</h2>
          <p>We may update this Privacy Policy from time to time.</p>
          <p>Changes will be reflected by updating the "Effective date" above.</p>
        </section>

        <section className="privacy-section">
          <h2>6. Contact Us</h2>
          <p>
            If you have any questions about this Privacy Policy or our data practices, please contact us at:{' '}
            <a href="mailto:info@ulagatamizhar.net">info@ulagatamizhar.net</a>
          </p>
        </section>
      </div>
    </div>
  );
}

export default SollaiSolPrivacy;
